import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import MyChoiceCard from '../../containers/Cards/MyChoice';
import PatientProvider from '../../containers/Providers/Patient';
import { RouteComponentProps, withRouter, generatePath } from 'react-router';
const MyChoices = (
  props: RouteComponentProps<{
    organizationId: string;
    patientId: string;
  }>,
) => {
  const gPath = generatePath(
    '/organization/:organizationId/patient/:patientId',
    props.match.params,
  );
  return (
    <PatientProvider patientId={props.match.params.patientId}>
      <Container fluid className="mt-3 mb-3">
        <Row noGutters>
          <Col className="">
            <MyChoiceCard onComplete={() => props.history.push(gPath)} />
          </Col>
        </Row>
      </Container>
    </PatientProvider>
  );
};

export default withRouter(MyChoices);
